import { takeLatest, put, call, select } from 'redux-saga/effects';
import { SET_QR_SETTINGS_SAGA } from "../sagaTypes";
import { loaderAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getDataForQRSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/set_qr_options`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerSetQRSettings(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('establishment', currentEstablishment);
        formData.append('logo', args.data.logo?.file || args.data.logo);
        formData.append('color', args.data.color);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем данные для qr-кода
            yield put(getDataForQRSagaAction());
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherSetQRSettings() {
    yield takeLatest(SET_QR_SETTINGS_SAGA, workerSetQRSettings);
}